import { DetectRolld } from "../../mixins/detectRolld";
let isRolld = DetectRolld.methods.isRolldStore();

export const newUiColors = {
    ButtonColour: "#222222",
    ButtonText: "#ffffff",
    TextColour: "#000000",
    CommonColor: "#222222",
    MenuHighlight: "#222222",
    MenuHighlightedText: "#222222",
    StatusPending: "#e0e0e0",
    TitleBar: "#ffffff",
    IconColor: "#222222",
    MenuBackground: "#ffffff",
    MenuText: "#222222",
    primaryBackgroundColour : "#d9d8d7 !important",
    CustomButtonColour: "#626262",
}

export const rolldDefaultMobileColors = {
  ButtonColour: "#ff0619",
  ButtonText: "#ffffff",
  CommonColor: "#FF0619",
  MenuHighlight: "#085748",
  MenuHighlightedText: "#ff0619",
  StatusPending: "#9BC1AB",
  TitleBar: "#fffbf2",
  MenuBackground: "#fffbf2",
  MenuText: "#085748",
  TextColour: "#085748",
};
export const rolldDefaultDesktopColors = {
  ButtonColour: "#ff0619",
  ButtonText: "#ffffff",
  CommonColor: "#FF0619",
  MenuHighlight: "#085748",
  MenuHighlightedText: "#ff0619",
  StatusPending: "#9BC1AB",
  TitleBar: "#fffbf2",
  MenuBackground: "#fffbf2",
  MenuText: "#085748",
  TextColour: "#085748",
};
export const defaultMobileColors = isRolld
  ? rolldDefaultMobileColors  :
        {
      ButtonColour: "#212529",
      ButtonText: "#ffffff",
      CommonColor: "#55696d",
      MenuHighlight: "#b7bbbb",
      MenuHighlightedText: "#212529",
      StatusPending: "#cfdafd",
      TitleBar: "#626262",
      MenuBackground: "#dddddd",
      MenuText: "#212529",
      CustomButtonColour: "#626262",
    };
export const defaultDesktopColors = isRolld
  ? rolldDefaultDesktopColors
  : {
      ButtonColour: "#212529",
      ButtonText: "#ffffff",
      CommonColor: "#55696d",
      MenuHighlight: "#b7bbbb",
      MenuHighlightedText: "#212529",
      StatusPending: "#cfdafd",
      TitleBar: "#626262",
      MenuBackground: "#dddddd",
      MenuText: "#343a40",
      CustomButtonColour: "#626262",
    };
export function defaultCommonStyles() {
  return {
    pageColor: {
      background: isRolld ? "#FFFBF2" : "rgba(255, 255, 255, 1)",
    },
  };
}
